import * as React from "react";
type Props = {
  className?: string,
};
function SvgPersonalized({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Personalized"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 1.42859C30.2567 1.42859 38.5714 9.7433 38.5714 20C38.5714 30.2567 30.2567 38.5714 20 38.5714C9.7433 38.5714 1.42859 30.2567 1.42859 20C1.42859 9.7433 9.7433 1.42859 20 1.42859ZM20.6466 9.23474L23.3697 15.0362C23.4709 15.2519 23.6729 15.4029 23.9084 15.4388L30.0545 16.3779C30.4444 16.4374 30.7122 16.8019 30.6527 17.1918C30.6301 17.3393 30.562 17.476 30.4578 17.5828L25.9661 22.1865C25.8077 22.3488 25.7358 22.5766 25.7723 22.8003L26.8265 29.2626C26.89 29.6519 26.6258 30.019 26.2365 30.0825C26.0784 30.1083 25.9161 30.0802 25.7759 30.0027L20.3456 27.0009C20.1305 26.882 19.8695 26.882 19.6545 27.0009L14.2241 30.0027C13.8789 30.1935 13.4443 30.0684 13.2534 29.7231C13.1759 29.5829 13.1478 29.4207 13.1736 29.2626L14.2277 22.8003C14.2642 22.5766 14.1923 22.3488 14.034 22.1865L9.54222 17.5828C9.26672 17.3004 9.27229 16.8482 9.55465 16.5727C9.66142 16.4685 9.79813 16.4004 9.94559 16.3779L16.0916 15.4388C16.3271 15.4029 16.5291 15.2519 16.6303 15.0362L19.3534 9.23474C19.521 8.87763 19.9464 8.72402 20.3035 8.89164C20.4544 8.96247 20.5758 9.08384 20.6466 9.23474Z"
        stroke="currentColor"
      />
    </svg>
  );
}
export default SvgPersonalized;
